import { Maths } from './maths';

// eslint-disable-next-line import/prefer-default-export
export const convertM2ToAc = m2 => {
  const factorOfConversationToAc = 4046.864224;
  // Parsed to a number first: Maths goes through Decimal, which accepts NaN
  // but throws on undefined.
  return Maths.divideSafeRound(Number.parseFloat(m2), factorOfConversationToAc);
};
